import React from 'react';
import '../../css/mapstyle.css';
import WithCallbacks from '../ReactSelectAsync/ReactSelectAsync';
import {QueryRenderer , graphql} from 'react-relay'
import environment from '../../RelayEnvironment'



export default class MyAreaDropdown extends React.Component {
constructor(props){
 super(props);

 this.state = {
       displayMenu: false,
       isSearchingUsAreas: true,
       isSearchingMyAreas: false,
       SearchAreaText:"",
      };

  this.showDropdownMenu = this.showDropdownMenu.bind(this);
  this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
// console.log("my area drop down props-->",props)
};

  showDropdownMenu(event) {
    event.preventDefault();
    this.setState({ displayMenu: true }, () => {
    });
  }

  hideDropdownMenu() {
    this.setState({ displayMenu: false }, () => {
    });

  }

  AreaSearchInputHandler = (SelectedArea) =>{
    if(this.props.onAreaSelected != null) {
        this.props.onAreaSelected(SelectedArea);
    }
    console.log("AreaSearchInputHandlerCalled", SelectedArea)
  }

  closeSelectIndicator = () => {
      return true;
  }

  render() {
    return (
        <div className="inner-srch-wrap">
           <div className="search-panel-card">
                <WithCallbacks {...this.props} closeSelectIndicator={this.closeSelectIndicator}
                     onAreaSelected = {this.AreaSearchInputHandler} isSearchingUsAreas = {this.state.isSearchingUsAreas}/>


              <span className="search-map-icon" ></span>
           </div>
        </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/MyAreaDropdown/MyAreaDropdown.js